import React from "react";
import { ReactComponent as Fb } from "../../assets/svg/fb.svg";
import { ReactComponent as Youtube } from "../../assets/svg/youtube.svg";
import { ReactComponent as X } from "../../assets/svg/X.svg";
import { ReactComponent as Lin } from "../../assets/svg/lin.svg";
import { ReactComponent as Mail } from "../../assets/svg/mail.svg";
import { ReactComponent as Phone } from "../../assets/svg/phone.svg";
import { ReactComponent as Loc } from "../../assets/svg/loc.svg";
import { ReactComponent as Send } from "../../assets/svg/Send.svg";
import birdlife from "../../assets/images/Birdlife.png"
import cepf from "../../assets/images/cepf.png"
import DIMFE from "../../assets/images/DIMFE.png"
const Footer = () => {
  return (
    <div className="w-full bg-[#006DC4]">
      {/* Adjust padding and spacing for different screen sizes */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 justify-around p-6 md:p-12 lg:p-24 gap-8">
        <div className="lg:col-start-1 lg:col-end-4">
          {/* Center image on smaller screens */}
          <div className="grid justify-items-center lg:justify-start">
            <img
              src={"assets/images/initialLogo.png"}
              alt="none"
              className="w-[150px] h-[180px] lg:w-[206px] lg:h-[232px]"
            />
            <div className="flex">
              <img alt="logo" src={birdlife} />
              <img alt="logo"  src={DIMFE} />
              <img alt="logo" src={cepf} />

            </div>
          </div>
        </div>

        <div className="lg:col-start-4 lg:col-end-7">
          <h1 className="text-white text-xl lg:text-2xl font-semibold">
            Lien utiles
          </h1>
          <div className="p-2">
            <ul>
              <li className="text-white font-medium">Observatoire</li>
              <li className="text-white font-medium">Données et solution</li>
              <li className="text-white font-medium">
                Evennement et ressources
              </li>
            </ul>
          </div>
        </div>

        <div className="lg:col-start-7 lg:col-end-10">
          <h1 className="text-white text-xl lg:text-2xl font-semibold mb-2">
            Contact
          </h1>
          <div>
            <ul>
              <div className="flex space-x-3 justify-between">
                <Loc />
                <li className="text-white text-left w-full font-medium">
                  Soliman, Nabeul
                </li>
              </div>
              <div className="flex space-x-3 justify-between">
                <Phone />
                <li className="text-white text-left w-full font-medium">
                  +216 12 345 678
                </li>
              </div>
              <div className="flex space-x-3 justify-between">
                <Mail />
                <li className="text-white text-left w-full font-medium">
                  gireausol@gmail.com
                </li>
              </div>
            </ul>
          </div>
        </div>

        <div className="lg:col-start-10 lg:col-span-3">
          <h1 className="text-white text-xl lg:text-2xl font-semibold">
            Inscrivez-vous à notre{" "}
            <span className="text-yellow-400">Newsletter</span> pour recevoir
            toutes nos actualités
          </h1>
          <div className="mt-4 flex flex-col lg:flex-row justify-center items-center bg-white">
            <input
              type="text"
              className="border border-gray-300 p-2 w-full lg:w-auto"
              placeholder="Entrez votre email"
            />
            <button
              type="submit"
              className="mt-2 lg:mt-0 lg:ml-4 px-4 py-2 bg-[#006DC4] uppercase text-white flex items-center"
            >
              <span className="text-white font-md">S'inscrire</span> <Send />
            </button>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-solid border-t-[1px] border-white"></div>

      {/* Footer bottom section */}
      <div className="h-11 flex flex-col lg:flex-row items-center justify-around bg-[#006DC4] py-4 lg:py-8">
        <p className="text-white font-thin text-sm text-center lg:text-left">
          Copyright © 2024. Tous les droits sont réservés.
        </p>
        <div className="flex space-x-4 mt-2 lg:mt-0">
          <Fb />
          <Youtube />
          <X />
          <Lin />
        </div>
      </div>
    </div>
  );
};

export default Footer;
